import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import '../blocks/menu/menu';
import '../blocks/header/header';
import '../blocks/modal/modal';
import '../blocks/popover/popover';
import '../blocks/select/select';
import '../blocks/snippet/snippet';
import '../blocks/tooltip/tooltip';

$('[data-toggle="tooltip"]').tooltip();

const tiers = {
	xs: '401px',
	s: '601px',
	m: '801px',
	l: '1051px',
	xl: '1401px',
	xxl: '1801px'
};

function above(tier) {
	const mq = window.matchMedia('only screen and (min-width: ' + tier + ')');
	return mq.matches;
}

// Header

const Hamburger = function () {
	let initialized = false;
	this.init = function ($links) {
		if (initialized) {
			return;
		}
		const list = $('<ul class="header__about"></ul>');
		$links.each(function () {
			const item = $('<li class="header__about-item"></li>');
			const link = $('<a class="link"></a>');
			link
				.attr('href', $(this).attr('href'))
				.append($(this).find('.text').text());
			item.append(link);
			list.append(item);
		});
		$('.header__top-wrapper').prepend(list);
		initialized = true;
	};
};

const hamburger = new Hamburger();

if (above(tiers.l)) {
	hamburger.init($('#menu a'));

}


// Snippets

$('.snippet').snippet('equalize');

let resizeTimer;

$(window).on('resize', () => {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(() => {
		$('.snippet').snippet('equalize');
		if (above(tiers.l)) {
			hamburger.init($('#menu a'));
		}
	}, 50);

});

$(() => {
	svg4everybody();
});

$('.snippet__button-favorite')
	.tooltip({
		icon: 'hearts',
		trigger: 'manual',
		title() {
			return $(this).is('.button_state_active') ?
				'Товар удален из избранного' :
				'Товар добавлен в избранное';
		}
	}).on('shown.bs.tooltip', function () {
		setTimeout(() => {
			$(this).tooltip('hide');
		}, 3000);
	});

$('.snippet__button-compare')
	.tooltip({
		icon: 'scales',
		trigger: 'manual',
		title() {
			return $(this).is('.button_state_active') ?
				'Товар удален из списка сравнения' :
				'Товар добавлен в сравнение';
		}
	})
	.on('shown.bs.tooltip', function () {
		setTimeout(() => {
			$(this).tooltip('hide');
		}, 3000);
	});



/** WEBPACK FOOTER **
 ** ./app/scripts/common.js
 **/